<template>
  <div v-if="anmalningsinfo != null" class="anmalning">
    <div class="grupp">
      <span class="fw-bolder"> {{ etikett }}: </span>
      <p v-if="anmalningsinfo.ovreText">
        {{ anmalningsinfo.ovreText }}
        <a
          v-if="anmalningsinfo.informationsUrl"
          :href="anmalningsinfo.informationsUrl"
          >{{ anmalningsinfo.informationsUrlText }}</a
        >
        {{ anmalningsinfo.nedreText }}
      </p>
    </div>    
    <div 
      v-if="sarskildBehorighetRubrik && sarskildBehorighet != null"
      class="sarskildbehorighet"
    >
      <h3>{{ sarskildBehorighetRubrik }}</h3>
      <div v-html="sarskildBehorighet"></div>
    </div>
    <div v-if="anmalningsinfo.oppenForAnmalan" class="anmalningsknapp">
      <a
        :href="anmalningsinfo.anmalanUrl"
        rel="nofollow"
        class="btn btn-primary w-100"
        >{{ anmalningsinfo.knapptext }}</a
      >
    </div>    
  </div>
</template>

<script>
import tillfallenservice from "../plugins/tillfallenservice";

export default {
  name: "Anmalningsknapp",
  props: {
    baseApiUrl: String,
    utbkod: String,
    tillfallesnamn: String,
    lang: String,
    etikett: String,
    sarskildBehorighetRubrik: String,
    sarskildBehorighet: String,
  },
  data: function () {
    return {
      anmalningsinfo: null,
    };
  },
  beforeMount() {
    this.getAnmalningsStatus();
  },
  methods: {
    getAnmalningsStatus: function () {
      tillfallenservice
        .anmalningsinfo(
          this.baseApiUrl,
          this.utbkod,
          this.tillfallesnamn,
          this.lang
        )
        .then((result) => {
          if (result && result.status === 200) {
            //console.log(result.data);
            this.anmalningsinfo = result.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
